import { tns } from 'tiny-slider'

(() => {
    const carousels = Array.from(document.querySelectorAll('.carousel--wrapper'))

    if(!carousels || carousels.length < 1) return

    carousels.forEach(carousel => {

        tns({
            container: carousel.querySelector('.carousel'),
            controlsContainer: carousel.querySelector('.carousel-controls'),
        })
    })

})()
